(ns frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view
  (:require
   [clojure.string :as s]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :refer [format-data]]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.style.theme.core :as theme]))


(defn heading-row-spanned
  [heading color]
  (into []
        (->> heading
             :cols
             (keep (fn [{:keys [span label]}]
                     (let [hide-bottom-border? (= span 1)]
                       {:text      (or label "")
                        :colSpan   span
                        :rowSpan   (if (= span 1) 1 1)
                        :border    (when hide-bottom-border? [true true true false])
                        :fillColor color
                        :bold      (when-not (= (theme/get-theme) :theme.lp-portal/capman) "bold")
                        :color     (theme/color [:lp-report :table :pdf :heading-color :fg])
                        :alignment "right"}))))))

(defn heading-row-heading
  [heading headers heading-count color title-in-heading?]
  (let [hide-top-border? (->> headers
                              (filter (fn [{:keys [_cols header-type]}]
                                        (= header-type :header-type/spanned)))
                              (first)
                              :cols
                              (keep (fn [{:keys [span _label]}]
                                      (= span 1))))
        capman? (= (theme/get-theme) :theme.lp-portal/capman)]
    (into []
          (->> heading
               :cols
               (map-indexed (fn [idx lbl]
                              {:text      (or lbl "")
                               :border    (cond capman?
                                                [false false false false]
                                                (and hide-top-border? (> heading-count 2))
                                                [false false true true]
                                                :else
                                                nil)
                               :fillColor color
                               :bold      (cond
                                            (and (= idx 0) title-in-heading?)
                                            "bold"
                                            capman?
                                            false
                                            :else
                                            "bold")
                               
                               :color     (theme/color [:lp-report :table :pdf :heading-color :fg])
                               :alignment (if (= idx 0)
                                            "left"
                                            "right")}))
               (vec)))))

(defn heading-row-info
  [heading color]
  (into []
        (->> heading
             :cols
             (mapv (fn [lbl]
                     {:text      (or lbl "")
                      :fillColor color
                      :color     (theme/color [:lp-report :table :pdf :heading-info-color :fg])
                      :alignment "right"})))))

(defn heading-rows
  [headers heading-count heading-color heading-info-color title-in-heading?]
  (->> headers
       (mapv (fn [header-row]
               (let [header-type (:header-type header-row)]
                 (case header-type
                   :header-type/spanned
                   (heading-row-spanned header-row heading-color)
                   :header-type/info
                   (heading-row-info header-row heading-info-color)
                   :header-type/heading
                   (heading-row-heading header-row headers heading-count heading-color title-in-heading?)
                   (str "No header type " (:header-type header-row))))))))

(defn stack-label
  ([label-text] (stack-label label-text nil))
  ([label-text text-color]
   {:text     (s/upper-case label-text)
    :fontSize 7
    :color    (or text-color (theme/color [:pdf :stack :label]))
    :margin   [0 0 0 8]
    :noWrap   true}))

(defn stack-value
  ([value] (stack-value value nil))
  ([value text-color]
   (merge {:text     value
           :bold     true
           :fontSize 16
           :margin   [0 0 0 -10]
           :color    (or text-color (theme/color [:pdf :stack :value]))}
          (when (= (theme/get-theme) :theme.lp-portal/lifeline)
            {:font "SuperiorTitleBlack"}))))

(defn data-row-stacked-pdf
  ([row] (data-row-stacked-pdf row nil))
  ([row text-color]
   (let [{:keys [row-data row-data-types row-decimals row-multipliers format-row empty-indicator-row row-type]} row
         data-heading (first row-data)
         data-value
         (format-data row-data-types
                      row-decimals
                      row-multipliers
                      format-row
                      empty-indicator-row
                      row-type
                      (second row-data))]
     (vec [[(stack-value data-value text-color)
            (stack-label data-heading text-color)]]))))


(defn data-row
  [{:keys [alignment-row highlight-row
           column-font-style-row column-style-row
           table-style _icon-config-table]
    :as   _parsed-data}
   {:keys [row-data row-highlight row-type row-font-style row-multipliers row-data-types row-decimals format-row
           empty-indicator-row row-style]
    :as   _row}
   {:keys [odd-color even-color row-index subheading-color subtotal-color total-color empty-line-color icons-row
           font-size text-color]}]
   (into
    []
    (->>
     row-data
     (map-indexed
      (fn [idx data]
        (let [column-alignment (nth alignment-row idx nil)
              column-color (nth highlight-row idx nil)
              column-text-style (nth column-font-style-row idx nil)
              column-style (nth column-style-row idx nil)
              icon-map (nth icons-row idx nil)
              default-cell-borders (case row-type
                                     "subtotal" [false true false true]
                                     "total" (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                                                [false true false false]
                                                [false true false true])
                                     [false false false false])
              font-size (cond (not (cu/blank-value? font-size))
                              font-size
                              (= (theme/get-theme) :theme.lp-portal/capman)
                              9
                              :else
                              6)]
          {:text
           [{:text (str (if-not (= idx 0)
                          (format-data row-data-types
                                       row-decimals
                                       row-multipliers
                                       format-row
                                       empty-indicator-row
                                       row-type
                                       data)
                          data) (when icon-map " "))
             :color (or text-color "#000000")
             :fontSize font-size}
            (when icon-map {:text (:icon icon-map)
                            :font "FontAwesome"
                            :color (:color icon-map)
                            :fontSize font-size})]
           :color     (or text-color "#000000")
           :fillColor (cond
                        (not (cu/blank-value? row-type))
                        (case row-type
                          "subheading"
                          subheading-color
                          "subtotal"
                          subtotal-color
                          "total"
                          total-color
                          "empty line"
                          empty-line-color)
                        (and (not (cu/blank-value? column-color)) (cu/blank-value? row-highlight))
                        column-color
                        (and (cu/blank-value? column-color) (not (cu/blank-value? row-highlight)))
                        row-highlight
                        (and (not (cu/blank-value? column-color)) (not (cu/blank-value? row-highlight)))
                        column-color ;;Column color is always on top of row color
                        (= table-style :table-style/none)
                        even-color
                        :else
                        (if (odd? row-index) odd-color even-color))
           :bold      (when-not (and (cu/blank-value? column-text-style) (cu/blank-value? row-font-style))
                        (or (= "bold" (cu/str-trim-lcase column-text-style))
                            (= "bold" (cu/str-trim-lcase row-font-style))))
           :italics   (when-not (and (cu/blank-value? column-text-style) (cu/blank-value? row-font-style))
                        (or (= "italic" (cu/str-trim-lcase column-text-style))
                            (= "italic" (cu/str-trim-lcase row-font-style))))
           :alignment (if-not (cu/blank-value? column-alignment)
                        column-alignment
                        (when-not (= idx 0)
                          (case row-data-types
                            :table-data-type/date
                            "right"
                            :table-data-type/currency
                            "right"
                            :table-data-type/multiple
                            "right"
                            :table-data-type/number
                            "right"
                            :table-data-type/percentage
                            "right"
                            :table-data-type/text
                            "left"
                            "right")))
           :border
           (cond-> default-cell-borders
             (= column-style "border left")
             (assoc 0 true)
             (= row-style "border top")
             (assoc 1 true)
             (= column-style "border right")
             (assoc 2 true)
             (= row-style "border bottom")
             (assoc 3 true))}))))))

(defn vertical-table-pdf
  [{:keys [parsed-data odd-row-background-color even-row-background-color heading-color heading-info-color
           subheading-color subtotal-color total-color empty-line-color stacked-rows? table-widths font-size title-in-heading?
           text-color]
    :as   _params}]
  (let [{:keys [heading-count headers rows pdf-column-width icon-config-table]} parsed-data 
        last-heading-idx (atom 0)
        heading-indexes (range (+ heading-count 1))
        heading-border-color-horizontal (fn [i]
                                          (cond
                                            (some #{i} heading-indexes)
                                            (theme/color [:lp-report :table :pdf :heading-border])
                                            (= (theme/get-theme) :theme.lp-portal/capman)
                                            "#d3d3d3"
                                            :else
                                          (theme/color [:palette :brand-3]))) ;;NOTE this color is for other borders, eg. subtotals
        heading-border-color-vertical (fn [_i]
                                        (cond
                                          (= (theme/get-theme) :theme.lp-portal/lifeline)
                                          (theme/color [:palette :granite])
                                          (= (theme/get-theme) :theme.lp-portal/capman)
                                          "#d3d3d3"
                                          :else
                                          (theme/color [:lp-report :table :pdf :heading-border])))
        full-width (vec (repeat (->> rows
                                     (first)
                                     :row-data
                                     (count)) ;; TODO fix, doesnt work as should
                                "*"))
        line-width (cond (= (theme/get-theme) :theme.lp-portal/capman)
                         0.8
                         :else
                         0.5)
        table-config {:layout   (merge {:hLineColor heading-border-color-horizontal
                                        :vLineColor heading-border-color-vertical
                                        :hLineWidth (fn [i]
                                                      (cond
                                                        stacked-rows?
                                                        nil
                                                        (and (= (theme/get-theme) :theme.lp-portal/lifeline)
                                                             (some #{i} heading-indexes))
                                                        0
                                                        :else
                                                        line-width))
                                        :vLineWidth (fn [_i] (if stacked-rows?
                                                               0
                                                               line-width))}
                                       (when (= (theme/get-theme) :theme.lp-portal/capman)
                                         {:paddingTop (fn [_i] 4)
                                          :paddingBottom (fn [_i] 0)}))
                      :color    ()
                      :fontSize (cond font-size 
                                      font-size
                                      (= (theme/get-theme) :theme.lp-portal/capman)
                                      9
                                      :else
                                      6)
                      :margin   [0 0 0 0]
                      :table    {:widths     (cond
                                               stacked-rows?
                                               ["auto" "*"]
                                               table-widths
                                               table-widths
                                               (or (empty? pdf-column-width) (some #(= nil %) pdf-column-width))
                                               full-width
                                               :else
                                               pdf-column-width)
                                 :headerRows heading-count
                                 :body       (concat
                                              (heading-rows headers heading-count heading-color heading-info-color title-in-heading?)
                                              (concat
                                               (->> rows
                                                    (map-indexed (fn [row-index row]
                                                                   (let [row-type (:row-type row)
                                                                         icons-row (when icon-config-table
                                                                                     (nth (->> icon-config-table
                                                                                               (drop heading-count))
                                                                                          row-index))
                                                                         row-idx (if (some #(= row-type %)
                                                                                           ["subheading" "subtotal"
                                                                                            "empty line" "total"])
                                                                                   (do (reset! last-heading-idx row-index) 0)
                                                                                   (- row-index @last-heading-idx))]
                                                                     (if stacked-rows?
                                                                       (data-row-stacked-pdf row text-color)
                                                                       (data-row parsed-data
                                                                                 row
                                                                                 {:odd-color        odd-row-background-color
                                                                                  :even-color       even-row-background-color
                                                                                  :row-index        row-idx
                                                                                  :subheading-color subheading-color
                                                                                  :subtotal-color   subtotal-color
                                                                                  :total-color      total-color
                                                                                  :empty-line-color empty-line-color
                                                                                  :icons-row        icons-row
                                                                                  :font-size        font-size
                                                                                  :text-color       text-color}))))))))}}]
    table-config))


(defn table
  ([data] (table data {}))
  ([{:keys [_rich-content _rich-content-path _figures] :as data} props]
   (let [removed-since-empty? (->> data
                                   :figures
                                   :rows
                                   (filter (fn [{:keys [row-data]}]
                                             (seq (remove nil? row-data))))
                                   (count)
                                   (= 0))]
     (if removed-since-empty?
       nil
       (card/card
        ""
        (vertical-table-pdf {:parsed-data              (:figures data)
                             :odd-row-background-color (if removed-since-empty?
                                                         (theme/color [:palette :danger])
                                                         (theme/color [:lp-report :table :pdf :odd-row :bg]))
                             :even-row-background-color (or (:even-row-background-color props)
                                                            (theme/color [:lp-report :table :pdf :even-row :bg]))
                             :heading-color            (theme/color [:lp-report :table :pdf :heading-color :bg])
                             :heading-info-color       (theme/color [:lp-report :table :pdf
                                                                     :heading-info-color :bg])
                             :subheading-color         (theme/color [:lp-report :table :pdf
                                                                     :subheading-color :bg])
                             :subtotal-color           (theme/color [:lp-report :table :pdf
                                                                     :subtotal-color :bg])
                             :total-color              (theme/color [:lp-report :table :pdf
                                                                     :total-color :bg])
                             :empty-line-color         (theme/color [:lp-report :table :pdf
                                                                     :empty-line-color :bg])
                             :stacked-rows?            (:stacked-rows? props)
                             :table-widths             (:table-widths props)
                             :font-size                (:font-size props)
                             :title-in-heading?        (:title-in-heading? props)
                             :text-color               (:text-color props)}))))))
